var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"type":"error"}},[_vm._v("404 Страница не найдена")])
}
var staticRenderFns = []

export { render, staticRenderFns }